import { BASE_PATH as C, BaseAPI as h, operationServerMap as d } from "../base.js";
import { DUMMY_BASE_URL as u, assertParamExists as v, createRequestFunction as f, serializeDataIfNeeded as B, setSearchParams as A, toPathString as P } from "../common.js";
import b from "axios";
var x = function(e) {
  return { cashierBenefitCompensationCompensate: async (r, n = {}) => {
    v("cashierBenefitCompensationCompensate", "cashierBenefitCompensationRequestDTO", r);
    const s = new URL("/cashier/settlement/benefit-compensations", u);
    let t;
    e && (t = e.baseOptions);
    const a = {
      method: "POST",
      ...t,
      ...n
    }, o = {}, i = {};
    o["Content-Type"] = "application/json", A(s, i);
    let p = t && t.headers ? t.headers : {};
    return a.headers = {
      ...o,
      ...p,
      ...n.headers
    }, a.data = B(r, a, e), {
      url: P(s),
      options: a
    };
  } };
}, m = function(e) {
  const r = x(e);
  return { async cashierBenefitCompensationCompensate(n, s) {
    var t, a;
    const o = await r.cashierBenefitCompensationCompensate(n, s), i = (t = e == null ? void 0 : e.serverIndex) !== null && t !== void 0 ? t : 0, p = (a = d["MemberCashierCompensationApi.cashierBenefitCompensationCompensate"]) === null || a === void 0 || (a = a[i]) === null || a === void 0 ? void 0 : a.url;
    return (c, l) => f(o, b, C, e)(c, p || l);
  } };
}, V = function(e, r, n) {
  const s = m(e);
  return { cashierBenefitCompensationCompensate(t, a) {
    return s.cashierBenefitCompensationCompensate(t.cashierBenefitCompensationRequestDTO, a).then((o) => o(n, r));
  } };
}, R = class extends h {
  cashierBenefitCompensationCompensate(e, r) {
    return m(this.configuration).cashierBenefitCompensationCompensate(e.cashierBenefitCompensationRequestDTO, r).then((n) => n(this.axios, this.basePath));
  }
};
export {
  R as MemberCashierCompensationApi,
  x as MemberCashierCompensationApiAxiosParamCreator,
  V as MemberCashierCompensationApiFactory,
  m as MemberCashierCompensationApiFp
};

//# sourceMappingURL=member-cashier-compensation-api.js.map